"use client";

import React from "react";
import { MonitorSmartphone, Hammer, BookOpen, Heart, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const pillars = [{
  title: "ICT Access",
  description: "Improving access to technology and digital learning so that children and young people can develop practical skills for the future.",
  icon: MonitorSmartphone,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1602004/img/pillar_education_joyhope.png",
  link: "/OurWorkPage"
}, {
  title: "Learning Environments",
  description: "Supporting safe, welcoming, and effective spaces where children can learn, grow, and reach their full potential.",
  icon: Hammer,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1602004/img/pillar_vocational_joyhope.png",
  link: "/OurWorkPage"
}, {
  title: "Educational Resources",
  description: "Helping provide the materials and practical support that schools and students need to make learning more accessible and effective.",
  icon: BookOpen,
  image: "https://touching-owl.10web.cloud/wp-content/uploads/2026/03/1.jpeg?v=e8lzgvxwxm4",
  link: "/OurWorkPage"
}, {
  title: "Community Support",
  description: "Working with communities and families to remove barriers to education and create opportunities for children to thrive.",
  icon: Heart,
  image: "https://touching-owl.10web.cloud/wp-content/uploads/2026/03/16.jpeg?v=kperwvuf8s",
  link: "/DonatePage"
}];
export default function OurPillarsOfEmpowerment() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="104368" id="our-core-pillars-of-support" className="overflow-hidden bg-background ![padding:0px_0px_80px_0px]">
      <div className="container mx-auto max-w-7xl px-4 sm:px-6 md:px-8">
        <div ref={ref} className={`mx-auto mb-10 max-w-3xl text-center transition-all duration-1000 ease-out sm:mb-12 md:mb-16 lg:mb-20 ${isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
          <h2 className="mb-4 sm:mb-5 md:mb-6 font-sans text-3xl font-bold tracking-tight text-primary sm:text-4xl md:text-5xl">
            Our Core Pillars of Support
          </h2>
          <p className="font-sans text-base leading-7 text-muted-foreground sm:text-lg sm:leading-8">
            We focus on key areas of support that help create better educational
            opportunities and stronger foundations for children and communities
            in Ghana.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4">
          {pillars.map((pillar, i) => {
          const Icon = pillar.icon;
          return <div key={pillar.title} data-index={i} className={`group relative flex flex-col transition-all duration-700 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0"}`} style={{
            transitionDelay: `${i * 150}ms`
          }}>
                <Link to={pillar.link} className="flex h-full flex-col rounded-[12px] outline-none focus-visible:ring-2 focus-visible:ring-ring">
                  <div className="relative mb-6 transition-transform duration-500 ease-out group-hover:-translate-y-2">
                    <AspectRatio ratio={1}>
                      <img src={pillar.image} alt={pillar.title} className="h-full w-full rounded-[12px] object-cover shadow-sm" />
                    </AspectRatio>

                    <div className="absolute -bottom-5 -right-2 rounded-full bg-background p-2 shadow-md transition-transform duration-500 group-hover:scale-110">
                      <div className="flex h-12 w-12 items-center justify-center rounded-full bg-secondary text-primary">
                        <Icon size={24} strokeWidth={2} />
                      </div>
                    </div>
                  </div>

                  <div className="flex flex-grow flex-col transition-transform duration-500 ease-out group-hover:-translate-y-1">
                    <h3 className="mb-3 font-sans text-[22px] font-bold leading-tight text-primary sm:text-[24px]">
                      {pillar.title}
                    </h3>
                    <p className="flex-grow font-sans text-[15px] leading-7 text-muted-foreground sm:text-[16px]">
                      {pillar.description}
                    </p>

                    <div className="mt-6 flex items-center gap-2 font-sans text-[15px] font-bold text-secondary opacity-100 transition-all duration-300 ease-out sm:text-[16px] md:opacity-0 md:-translate-x-4 md:group-hover:translate-x-0 md:group-hover:opacity-100">
                      Learn More
                      <ArrowRight size={18} className="transition-transform duration-300 group-hover:translate-x-1" />
                    </div>
                  </div>
                </Link>
              </div>;
        })}
        </div>
      </div>
    </section>;
}